import React, { useEffect, useState } from "react";
import copy from "simple-copy-to-clipboard";

import { Plate } from "../helpfull/Plate";
import { HeaderTitle } from "../helpfull/HeaderTitle";
import { AnalyticsButton } from "../helpfull/AnalyticsButton";
import { TinyButton } from "../helpfull/TinyButton";
import { getTasks, postTaskCompleted } from "./utils/serverTasks";

import BEM from "./Accumulative.module.scss";
import headingicon from "./assets/headingicon.svg";
import { Task } from "./Task";
import {
  toBeautifullText,
  toMonthDateAndMonthNumber,
  toWeekDay,
} from "./utils/dateTransformations";
import { Link } from "react-router-dom";

export const Accumulative = () => {
  const [tasks, setTasks] = useState("loading");
  const [isAnalyticsVisible, setIsAnalyticsVisible] = useState(false);
  const [foldingStatus, setFoldingStatus] = useState("overdue+upcoming");

  const loadTasks = async () => {
    setTasks("loading");
    const tasks = await getTasks();
    setTasks(tasks);
  };

  const postComplete = async (id) => {
    setTasks("loading");
    await postTaskCompleted(id, new Date());
    loadTasks();
  };

  const handleFoldButtonCLick = () => {
    switch (foldingStatus) {
      case "overdue+upcoming":
        setFoldingStatus("overdue+upcoming+thisWeek");
        break;
      case "overdue+upcoming+thisWeek":
        setFoldingStatus("overdue+upcoming+thisWeek+farFuture");
        break;
      case "overdue+upcoming+thisWeek+farFuture":
        setFoldingStatus("overdue+upcoming");
        break;
      default:
        console.error("ERROR");
        break;
    }
  };

  const handleAnalyticsClick = () => {
    alert(copy(localStorage.getItem("stats/accumulative")));
  };

  useEffect(() => loadTasks(), []);

  return (
    <Plate>
      <div className={BEM.block}>
        <header className={BEM.header}>
          <HeaderTitle title="Накопичувальні звички" icon={headingicon} />
          <AnalyticsButton
            onClick={() => setIsAnalyticsVisible(!isAnalyticsVisible)}
          />
        </header>

        {isAnalyticsVisible && (
          <div>
            <button onClick={handleAnalyticsClick}>Click to copy data</button>
          </div>
        )}

        <main className={BEM.content}>
          {tasks !== "loading" &&
            foldingStatus.includes("overdue") &&
            !!tasks?.overdue?.length && (
              <div className={BEM.typeGroup + " " + BEM.typeGroup___red}>
                <h4 className={BEM.groupTitle}>Протерміновані</h4>
                {tasks.overdue.map((task) => (
                  <Task
                    key={task.id}
                    title={!task.link ? task.title : <Link className={BEM.link} to={task.link}>{task.title}</Link>}
                    nextDate={toMonthDateAndMonthNumber(task.nextDate)}
                    buttonColor="#FF4A4A"
                    onComplete={() => postComplete(task.id)}
                  />
                ))}
              </div>
            )}

          {tasks !== "loading" && foldingStatus.includes("upcoming") && (
            <div className={BEM.typeGroup + " " + BEM.typeGroup___yellow}>
              <h4 className={BEM.groupTitle}>На днях:</h4>
              {!!tasks?.upcoming?.length ? (
                tasks.upcoming.map((task) => (
                  <Task
                    key={task.id}
                    title={!task.link ? task.title : <Link className={BEM.link} to={task.link}>{task.title}</Link>}
                    nextDate={toBeautifullText(task.nextDate)}
                    buttonColor="#E3FF3A"
                    onComplete={() => postComplete(task.id)}
                  />
                ))
              ) : (
                <p className={BEM.allDoneMessage}>✔ На днях все ок</p>
              )}
            </div>
          )}

          {tasks !== "loading" && foldingStatus.includes("thisWeek") && (
            <div className={BEM.typeGroup + " " + BEM.typeGroup___green}>
              <h4 className={BEM.groupTitle}>Цього тижня:</h4>
              {!!tasks?.thisWeek?.length ? (
                tasks.thisWeek.map((task) => (
                  <Task
                    key={task.id}
                    title={!task.link ? task.title : <Link className={BEM.link} to={task.link}>{task.title}</Link>}
                    nextDate={toWeekDay(task.nextDate)}
                    buttonColor="#5AFF3F"
                    onComplete={() => postComplete(task.id)}
                  />
                ))
              ) : (
                <p className={BEM.allDoneMessage}>✔ Все ок</p>
              )}
            </div>
          )}

          {tasks !== "loading" && foldingStatus.includes("farFuture") && (
            <div className={BEM.typeGroup + " " + BEM.typeGroup___cyan}>
              <h4 className={BEM.groupTitle}>В майбутньому:</h4>
              {!!tasks?.farFuture?.length ? (
                tasks.farFuture.map((task) => (
                  <Task
                    key={task.id}
                    title={!task.link ? task.title : <Link className={BEM.link} to={task.link}>{task.title}</Link>}
                    nextDate={toMonthDateAndMonthNumber(task.nextDate)}
                    buttonColor="#6DFFCB"
                    onComplete={() => postComplete(task.id)}
                  />
                ))
              ) : (
                <p className={BEM.allDoneMessage}>✔ Все виконано</p>
              )}
            </div>
          )}

          {tasks === 'loading' && <p className={BEM.loadingMessage}>Loading...</p>}

          <TinyButton onClick={handleFoldButtonCLick} className={BEM.tinyBtn}>
            {foldingStatus === "overdue+upcoming" && "Показати цьоготижневі"}
            {foldingStatus === "overdue+upcoming+thisWeek" &&
              "Показати всі майбутні"}
            {foldingStatus === "overdue+upcoming+thisWeek+farFuture" &&
              "Згорнути"}
          </TinyButton>
        </main>
      </div>
    </Plate>
  );
};
